import React from 'react';
import SparkleIcon from './SparkleIcon';
import style from './AiRecommendBox.module.css';

const AiRecommendBox = ({ title = 'AI추천', description, onClick }) => {
    return (
        <div className={style.WrapBox}>
            <button type="button" className={style.box} onClick={onClick}>
                <div className={style.inner}>
                    <div className={style.head}>
                        <span className={style.title}>
                            <SparkleIcon size={22} />
                            {title}
                        </span>
                        <span className={style.cta}>챗봇 ›</span>
                    </div>
                    <p className={style.desc}>
                        {description ?? (
                            <>
                                AI가 당신의 건강을 위해 추천합니다. AI가 당신의 건강을 위해 추천합니다.AI가 당신의 건강을 위해 추천합니다.
                            </>
                        )}
                    </p>
                </div>
            </button>
        </div>
    );
};

export default AiRecommendBox;